import Skeleton from "react-loading-skeleton";
import { Statistic } from "../types/statistics.types";
import DoughnutChart from "./doughnut-chart";
import LegendItem from "./legend-item";
import PolarAreaChart from "./polar-area-chart";
import RoseChart from "./rose-chart";
import './statistics-section.chart-type.scss';
import SkeletonChartTypeLegendItem from "./skeletons/chart-type.legend-item";

interface StatisticsSectionChartTypeProps {
    data: Statistic[];
    isLoading?: boolean;
}

const StatisticsSectionChartType: React.FC<StatisticsSectionChartTypeProps> = ({ data, isLoading = false }) => {

    const colors = data.map((statistic) => statistic.color);
    const quantitativePercentValues = data.map((statistic) =>
        +statistic.quantitativePercent.toFixed(1)
    );
    const qualitativePercentValues = data.map((statistic) =>
        +statistic.qualitativePercent.toFixed(1).toString()
    );
    return (
        <div className='statistic-section-chart-type flex-row flex-align-start-center flex-gap-10'>
            {isLoading ?
                <>
                    <Skeleton
                        className="skeleton-doughnut"
                        circle
                        width={240}
                        height={240}
                        highlightColor="#007bff" 
                    />
                    <Skeleton
                        className="skeleton-doughnut"
                        circle
                        width={240}
                        height={240}
                        highlightColor="#007bff"  />
                        <div className='flex-row flex-gap-20 width-100 flex-wrap'>
                            {Array.from({ length: 3 }).map((_, idx) =>
                                <SkeletonChartTypeLegendItem key={idx}/>
                            )}
                        </div>
                </> :
                <>
                    <DoughnutChart
                        values={quantitativePercentValues}
                        backgroundColors={colors}
                        centerText='Number of Transactions'
                    />
                    <DoughnutChart
                        values={qualitativePercentValues}
                        backgroundColors={colors}
                        centerText='Value of Transactions'
                    />

                    <div className='flex-row flex-gap-20 width-100 flex-wrap'>
                                {
                                    data.map(statistic =>
                                        <LegendItem
                                            key={statistic.id}
                                            id={statistic.id}
                                            color={statistic.color}
                                            name={statistic.name}
                                            quantitativePercent={statistic.quantitativePercent}
                                            quantitativeValue={statistic.quantitativeValue}
                                            qualitativePercent={statistic.qualitativePercent}
                                            qualitativeValue={statistic.qualitativeValue}

                                        />
                                    )
                                }


                    </div>
                </>
            }
        </div>
    )
}

export default StatisticsSectionChartType;